<script setup lang="ts">
import { useUser } from '@/modules/auth/store/user.store';
import { computed, ref } from 'vue';
import type { MenuItem } from 'primevue/menuitem';
import { useAuthStore } from '@/modules/auth/store/auth.store';

const user = useUser();
const auth = useAuthStore();
const userMenu = ref();

const userMenuItems = computed<MenuItem[]>(() => {
  return [
    {
      label: 'User',
      items: [
        {
          label: 'Enable BETA',
          icon: 'pi pi-heart',
          visible: !user.ephemeral.beta,
          command: () => {
            user.enterBetaMode();
          },
        },
        {
          label: 'Leave BETA',
          icon: 'pi pi-heart-fill',
          visible: user.ephemeral.beta,
          command: () => {
            user.leaveBetaMode();
          },
        },
        {
          label: 'Logout',
          icon: 'pi pi-sign-out',
          command: () => {
            auth.logout();
          },
        },
      ],
    },
  ];
});

const toggle = (event: Event) => {
  userMenu.value.toggle(event);
};
</script>

<template>
  <Button
    v-if="user.data !== null"
    type="button"
    @click="toggle"
    aria-haspopup="true"
    aria-controls="overlay_menu"
    severity="secondary"
  >
    {{ user.data.name }} {{ user.data.surname
    }}<i class="pi pi-angle-down ml-2" />
  </Button>
  <Menu ref="userMenu" id="overlay_menu" :model="userMenuItems" :popup="true">
    <template #item="{ item, props }">
      <router-link
        v-if="item.route"
        v-slot="{ href, navigate }"
        :to="item.route"
        custom
      >
        <a :href="href" v-bind="props.action" @click="navigate">
          <span :class="item.icon" />
          <span class="ml-2">{{ item.label }}</span>
        </a>
      </router-link>
      <a v-else :href="item.url" :target="item.target" v-bind="props.action">
        <span :class="item.icon" />
        <span class="ml-2">{{ item.label }}</span>
      </a>
    </template>
  </Menu>
</template>

<style scoped></style>
